import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'
import { useNavigate } from 'react-router-dom'
import { FaEdit, FaTrashAlt, FaUserPlus } from 'react-icons/fa'

export default function AllDepartments() {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [departments, setDepartments] = useState([])
  const [selectedDepartment, setSelectedDepartment] = useState(null)

  const fetchDepartments = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_admin_departments/`, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Department Res:', res)

      if(res.status === 200){
        setDepartments(res.data.data)
      }else{
        toast.error('Failed to fetch departments')
      }
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Department'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchDepartments()
  },[token])
  console.log('Departments:', departments)

  const handleDelete = async(id) => {
    console.log('Department Id:', id)

    if(!id){
      toast.error('Invalid Department id')
      return
    }

    try{
      const res = await axios.delete(`${config.baseurl}delete_department/${id}/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('Department Deleted Successfully')
      await fetchDepartments()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Department'

      toast.error(message)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <AdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL Departments
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all registered departments in one place.
        </p>
      </div>

      <div className='max-w-7xl mx-auto px-6 pb-10'>
        <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full table-auto'>
              <thead>
                <tr className='text-center border-b border-slate-300'>
                  <th className='px-3 py-2 whitespace-nowrap'>No</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Department Name</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Description</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Action</th>
                </tr>
              </thead>

              <tbody>
                {departments.length > 0 ? (
                  departments.map((item, index) => (
                    <tr
                      key={item.id}
                      className='text-center border-b border-b-slate-300'
                    >
                      <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.department_name}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.description}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>
                        <div className='flex items-center justify-center gap-3'>
                          <button
                            title='Edit'
                            onClick={() => {
                              setSelectedDepartment(item)
                              navigate(`/admin/edit_department/${item.id}`)
                            }}
                            className='bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600'
                          >
                            <FaEdit/>
                          </button>

                          <button
                            title='Delete'
                            onClick={() => handleDelete(item.id)}
                            className='bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600'
                          >
                            <FaTrashAlt/>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className='text-center py-6'
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
